/* eslint-disable @typescript-eslint/no-explicit-any */
import { BetPickDetail } from '@mobx/stores/kol/kol-store';
import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';
import FeatureStar from '@public/images/kol/Star.svg';
import BetPickButton from './bet-pick-button';
import BetPickCaption from './bet-pick-caption';
import { useTranslation } from 'next-i18next';
import WinPlace from './WinPlace';
import {
    CMSData,
    isCOMBI,
    isWinPLA,
    oddsDropBlock,
    oddsTypes,
    RStatus,
    SCRRStatus,
    SCRStatus,
} from '@src/utils/kolBetpickUtils';
import BetPickTable from './BetPickTable';
import { GetOddsDataQuery } from '@src/hooks/GetOddsDataQuery';
import { format } from 'date-fns';
import OddsLastUpdate from '@components/odds-last-update/OddsLastUpdate';
import OddsStore from '@mobx/stores/kolBetpick/kolOddsLastDate';
import { withBasePath, withFullPath } from '@src/common/path-convert';
import { observer } from 'mobx-react-lite';
import bettingStrategyStore from '@mobx/stores/bettingStrategy-store';
import { reaction } from 'mobx';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { ContentBlockFragment } from '@graphqlTypes/sitecore';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';
import isSharePageStore from '@mobx/stores/isShare-store';
import { DeepReadonly } from '@src/utils/type-utils';

type Props = {
    raceRunner: any[];
    oddsList: any[];
    betpickDetail: DeepReadonly<BetPickDetail>;
    type: 'leader' | 'race';
    jsBridge: any;
    index?: number;
    videoEnable?: boolean;
    isKolProfile?: boolean;
    contentBlock?: ContentBlockFragment | null;
};

const BetPickNewEntry = ({
    index,
    raceRunner,
    oddsList,
    betpickDetail,
    type,
    videoEnable,
    isKolProfile = false,
    jsBridge,
    contentBlock,
}: Props) => {
    // console.log('raceRunner====', raceRunner);
    const { i18n, t } = useTranslation('kol');
    const isSharePage = isSharePageStore.isSharePage;
    // console.log('isSharePage----', isSharePage);
    const betpick = betpickDetail.betpick;
    const displayOdds = betpickDetail.raceDay?.displayOdds?.boolValue ?? false;
    const betTypeName = betpick.betPickType?.targetItem?.name ?? '';
    const lang = i18n.language.toLowerCase() === 'en-us';
    /** 当button status 是  Strike, UI变更*/
    const isStrike = betpick.buttonStatus?.value === 'Strike';
    /** lastupdate 从mobx取出 */
    const MobxLastupdate = OddsStore.uniqueOddsLastDates;

    const { bettingStrategyType, singleTipsIcon, singleTips } = betpick;

    const showBettingStrategy = () => {
        if (bettingStrategyType?.value === 'One total tip') {
            const isShow = singleTips?.rendered?.trim() !== '';
            bettingStrategyStore.setBettingBTNList(isShow);
            return isShow;
        } else if (bettingStrategyType?.value === 'Multiple tips') {
            const isShow = tableData().some((item: any) => item.whiteText.trim() !== '');
            bettingStrategyStore.setBettingBTNList(isShow);
            return isShow;
        } else {
            bettingStrategyStore.setResetList();
            return false;
        }
    };

    /** 只有一个tip显示 */
    const isOnlyOneTip = bettingStrategyType?.value === 'One total tip';

    /** 常规数据 */
    const [generalData, setGeneralData] = useState<any[]>([]);
    /** win/PLACE数据 */
    const [winPLAData, setWinPLAData] = useState<any[]>([]);
    /** 组合数据 */
    const [combinedData, setCombinedData] = useState<any>();
    /** REFUND 状态数据 是否停售or結束 */
    const [refundData, setRefundData] = useState({
        WIN: false,
        PLA: false,
        QIN: false,
        QPL: false,
        TRI: false,
    });
    // Whiteboard open
    const [isOpen, setIsOpen] = useState(bettingStrategyStore.bettingDefault);

    const toggleOpen = () => {
        nonPageTracker(
            {
                eventID: isOpen
                    ? TrackingEvent.CollapseBettingStrategy
                    : TrackingEvent.ExpandBettingStrategy,
                raceID: `${betpickDetail?.raceDay?.name}/${betpickDetail?.race?.name}`,
                kolName: betpick.kol?.targetItem?.name,
            },
            { article: convertArticleInfo(contentBlock) }
        );

        setIsOpen((prev) => !prev);
    };
    /** 是否显示bet Now */
    // const [showBetNow, setShowBetNow] = useState(false);

    /** odds 数据请求 */
    const getOddsData = async () => {
        const racesNo = betpickDetail?.race?.raceNo?.numberValue ?? 0;
        const raceDay = format(
            new Date(betpickDetail?.raceDay?.raceDayDate?.dateValue ?? 0),
            'yyyy-MM-dd'
        );

        try {
            const oddsResult = await GetOddsDataQuery(
                raceDay,
                betpickDetail?.raceDay?.venueCode?.value ?? '',
                racesNo
            );
            const data = oddsResult[0]?.pmPools ?? [];
            processData(data, lang, t);
        } catch (error) {
            console.error('Error fetching odds data:', error);
        }
    };

    /** 白板数据 */
    const tableData = () => {
        if (isCOMBI.includes(betTypeName)) {
            return combinedData && combinedData?.horseList ? combinedData?.horseList : [];
        } else if (betTypeName === isWinPLA) {
            return winPLAData || [];
        } else {
            return generalData || [];
        }
    };

    // console.log('tableData===========', tableData());

    /** 数据处理 */
    const processData = (kolOddsList: any[] = [], lang = true, t: any) => {
        const betPickTypeName = betpick.betPickType?.targetItem?.name ?? '';
        const newOddsList = isKolProfile ? kolOddsList : oddsList;

        // console.log('newOddsList=================', newOddsList);
        /** 检查 REFUND 状态 */
        const checkRefundStatus = (oddsType: string) => {
            return newOddsList.some(
                (item) => item.oddsType === oddsType && item.status.includes('REFUND')
            );
        };

        // 更新 REFUND 状态
        const updatedRefundData = oddsTypes.reduce(
            (acc, type) => {
                acc[type as keyof typeof acc] = checkRefundStatus(type);
                return acc;
            },
            {
                WIN: false,
                PLA: false,
                QIN: false,
                QPL: false,
                TRI: false,
            } as { WIN: boolean; PLA: boolean; QIN: boolean; QPL: boolean; TRI: boolean }
        );
        setRefundData(updatedRefundData);

        const data = CMSData(betpick, raceRunner, newOddsList, lang, t) ?? [];

        // 以下注释逻辑暂不开放，用于2025。4月逻辑
        // /** 判断是否开卖 */
        // const isStartSell = newOddsList.some(
        //     (item) => item.oddsType === 'WIN' && item.status === 'START_SELL'
        // );
        // /** 判断是否SCR or '---' */
        // const hasScrOdds = data.some(
        //     (item: any) => item.oddsValue === 'SCR' || item.oddsValue === '---'
        // );
        // /** show bet now 按钮 */
        // setShowBetNow(isStartSell && !hasScrOdds);

        if (isCOMBI.includes(betPickTypeName)) {
            // console.log('组合data---', data);
            setCombinedData(data);
        } else if (betPickTypeName === isWinPLA) {
            // console.log('winPLA===data---', data);
            setWinPLAData(data);
        } else {
            // console.log('常规data---', data);
            setGeneralData(data);
        }
    };

    useEffect(() => {
        const disposer = reaction(
            () => bettingStrategyStore.bettingDefault,
            (newValue) => {
                setIsOpen(newValue);
            }
        );

        return () => {
            disposer();
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            await getOddsData();
        };

        if (isKolProfile) {
            fetchData(); // 在 isKolProfile 为 true 时获取数据
        } else {
            processData([], lang, t); // 在 isKolProfile 为 false 时直接处理数据
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isKolProfile, betpick, raceRunner, oddsList]);

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (isKolProfile) {
            interval = setInterval(async () => {
                await getOddsData();
            }, 300000);
        }

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isKolProfile]);

    /** 表格内容 */
    const tableBlock = () => {
        if (isCOMBI.includes(betTypeName)) {
            return (
                <BetPickTable
                    combinedData={combinedData}
                    betTypeName={betTypeName}
                    displayOdds={displayOdds}
                    refundData={refundData}
                />
            );
        }

        if (betTypeName === isWinPLA) {
            return (
                <WinPlace
                    winPLAData={winPLAData}
                    displayOdds={displayOdds}
                    refundData={refundData}
                />
            );
        }

        return (
            <div className='w-full'>
                <table className='w-full border-collapse text-[14px]'>
                    <thead>
                        <tr
                            style={{
                                borderBottom: `1px solid #E0E0E0`,
                                transform: 'translateY(-2px)',
                            }}
                        >
                            <th className='text-left text-[11px] font-normal'>{t('horse')}</th>
                            {displayOdds && (
                                <th className='text-center text-[11px] font-normal w-[36px]'>
                                    {betTypeName === 'PLA' ? t('Pla') : t('Win')}
                                </th>
                            )}
                        </tr>
                        <tr className='h-[1px]' />
                    </thead>

                    <tbody>
                        <tr className='h-1' />
                        {generalData.map((i, index) => {
                            // console.log('WIN---i------', i);
                            // TODO: odds 会返回SCR 或者 --- 的情况
                            // const isSCR = i.oddsValue === 'SCR';
                            // console.log(`refundData==${i.name_en}====`, refundData);
                            const isSCR = SCRStatus.includes(i.status) || i.oddsValue === 'SCR';
                            const isR = RStatus.includes(i.status);
                            const isSCRR = SCRRStatus.includes(i.status);
                            const noBG =
                                betTypeName === 'PLA'
                                    ? i.oddsValue === 'SCR' ||
                                      i.oddsValue === '---' ||
                                      refundData.WIN
                                    : i.oddsValue === 'SCR' ||
                                      i.oddsValue === '---' ||
                                      refundData.PLA;

                            return (
                                <tr
                                    key={index}
                                    className='text-[13px] font-bold text-black pt-[5px] h-[20px]'
                                >
                                    <td>
                                        {`${i.no}. ${isR || isSCRR ? t('betpick.r') : ''}${
                                            lang ? i.name_en : i.name_ch
                                        }`}
                                        {(isSCR || isSCRR) && ` (${t('betpick.scratched')})`}
                                    </td>
                                    {displayOdds && (
                                        <td className={classNames('text-center text-[#333]')}>
                                            <div
                                                className={`${
                                                    !noBG &&
                                                    oddsDropBlock(i.hotFavourite, i.oddsDropValue)
                                                }`}
                                            >
                                                {betTypeName === 'PLA'
                                                    ? refundData.PLA
                                                        ? '---'
                                                        : isSCR || isSCRR
                                                        ? `${t('betpick.scratched')}`
                                                        : i.oddsValue
                                                    : refundData.WIN
                                                    ? '---'
                                                    : isSCR || isSCRR
                                                    ? `${t('betpick.scratched')}`
                                                    : i.oddsValue}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div
            className={classNames(
                'relative overflow-clip flex flex-col items-stretch bg-white min-h-[158px] px-3 pb-6 rounded-[8px]',
                { 'border-[#FF9900]': betpick.isFeatured?.boolValue },
                { 'border-[4px]': betpick.isFeatured?.boolValue },
                { 'border-white': !betpick.isFeatured?.boolValue },
                { 'pt-[30px]': isStrike }
            )}
            style={{ boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)' }}
        >
            <div>
                <BetPickCaption
                    index={index}
                    betpickDetail={betpickDetail}
                    type={type}
                    videoEnable={videoEnable}
                    jsBridge={jsBridge}
                    contentBlock={contentBlock}
                ></BetPickCaption>
            </div>
            {type === 'leader' && (
                <div className='font-bold min-h-[16px] text-[13px]'>
                    {betpick.betPickType?.targetItem?.betTypeName?.value}
                </div>
            )}
            <div className='grow pt-1 md:pt-2 leading-[16px]'>
                <div className='flex flex-col  items-start align-middle mt-2'>
                    {tableBlock()}
                    {/* 
                    用于2025.4月需求，descope掉了，待确定发布时间
                    {showBetNow && (
                        <div className='w-full'>
                            <BetPickButton
                                betpickDetail={betpickDetail}
                                striketype='new'
                            ></BetPickButton>
                        </div>
                    )}
                    */}
                    <div className='w-full'>
                        <BetPickButton betpickDetail={betpickDetail}></BetPickButton>
                    </div>
                    {/* hide betting strategy */}
                    {showBettingStrategy() && (
                        <div className='w-full flex justify-center items-center flex-col mt-3'>
                            <div
                                className='font-medium text-sm text-[#003C84] flex items-center'
                                onClick={toggleOpen}
                            >
                                <img
                                    className={`w-5 h-5 mr-1`}
                                    src={withBasePath('/images/kol/i-win2.svg')}
                                    alt=''
                                    loading='lazy'
                                />
                                {isOpen ? t('HideBetting') : t('ShowBetting')}
                                <img
                                    className={`w-5 h-5 ml-1 transition-transform duration-300 ${
                                        isOpen ? 'rotate-180' : ''
                                    }`}
                                    src={withBasePath('/images/kol/i-down.svg')}
                                    alt=''
                                    loading='lazy'
                                />
                            </div>

                            {/* Whiteboard */}
                            <div className='w-full'>
                                <div
                                    className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
                                        isOpen ? 'max-h-[90000000px]' : 'max-h-0'
                                    }`}
                                >
                                    {/* content */}
                                    {isOnlyOneTip ? (
                                        <>
                                            <div className='pt-2' key={index}>
                                                {singleTips?.rendered && (
                                                    <div className='bg-[#EAF5FF] rounded py-2 px-2 flex items-center relative'>
                                                        {singleTipsIcon?.src && (
                                                            <img
                                                                className={`w-6 h-6 mr-2`}
                                                                src={withFullPath(
                                                                    singleTipsIcon?.src
                                                                )}
                                                                alt=''
                                                                loading='lazy'
                                                            />
                                                        )}
                                                        <div
                                                            className='text-sm text-black font-normal break-normal'
                                                            dangerouslySetInnerHTML={{
                                                                __html: singleTips?.rendered || '',
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {tableData().length > 0 &&
                                                tableData().map((i: any, index: number) => (
                                                    <div className='pt-2' key={index}>
                                                        {i.whiteText && (
                                                            <div className='text-sm font-bold text-black'>
                                                                {i.whiteName}
                                                            </div>
                                                        )}
                                                        {i.whiteText && (
                                                            <div className='bg-[#EAF5FF] rounded py-2 px-2 flex items-center relative mt-2'>
                                                                <div className='tooltipStyleA'></div>
                                                                {i.whiteIcon && (
                                                                    <img
                                                                        className={`w-6 h-6 mr-2`}
                                                                        src={withFullPath(
                                                                            i.whiteIcon
                                                                        )}
                                                                        alt=''
                                                                        loading='lazy'
                                                                    />
                                                                )}
                                                                <div
                                                                    className='text-sm text-black font-normal break-normal'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: i.whiteText || '',
                                                                    }}
                                                                ></div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {betpick.isFeatured?.boolValue && (
                <FeatureStar className='absolute -bottom-1 -right-1'></FeatureStar>
            )}
            {MobxLastupdate.length > 0 && displayOdds && !isSharePage && (
                <OddsLastUpdate curIndex={index} />
            )}
        </div>
    );
};

export default observer(BetPickNewEntry);
